export function isNullOrUndefined(value: any): value is undefined | null {
  return value === null || value === undefined;
}

export function isUndefined(value: any): value is undefined {
  return value === undefined;
}
